import { CSSProperties } from 'react';
import * as STYLE from '../../UIConstants';
import { CONSTANTS } from '../../UIConstants';

export const graphStyle: CSSProperties = {
    container: {
        display: STYLE.CONSTANTS.DISPLAY.FLEX,
        flexGrow: CONSTANTS.FLEX_GROW.ONE,
        flexDirection: CONSTANTS.FLEX_DIRECTION.COLUMN
    }
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/styles/Layout/AreaGraph.ts